import { render, staticRenderFns } from "./Secure.vue?vue&type=template&id=01156d81&scoped=true&"
import script from "./Secure.vue?vue&type=script&lang=js&"
export * from "./Secure.vue?vue&type=script&lang=js&"
import style0 from "./Secure.vue?vue&type=style&index=0&id=01156d81&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01156d81",
  null
  
)

export default component.exports